import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { updateAlert } from '../redux/actions';
import NoData from '../components/NoData';
import axios from 'axios';
import MyModelsCard from '../components/MyModelsCard';
import '../css/MyModels.css';

function MyModels(props) {
  const { user, handleAlert } = props;

  const [models, setModels] = useState([]);

  useEffect(() => {
    axios({
      method: "get",
      url: `/api/m2d/models/getModelByUserId/${user.id}`
    }).then((res) => {
      setModels(res.data);
    }).catch(err => {
      console.log(err);
      handleAlert("error", err.message, 3000);
    })
  }, [user, handleAlert]);

  return (
    <>
      <div className="page-content">
        {models.length === 0 ? (
          <NoData info="You don't have any model" />
        ) : (
          <div className="my-models-model">
            {models.map((model, index) => {
              return <MyModelsCard key={index} model={model} />
            })}
          </div>
        )}
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.main.user,
    role: state.m2d.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyModels)
